import { render } from "./smsSettingsNew.vue?vue&type=template&id=1a001824&scoped=true"
import script from "./smsSettingsNew.vue?vue&type=script&lang=js"
export * from "./smsSettingsNew.vue?vue&type=script&lang=js"

import "./smsSettingsNew.vue?vue&type=style&index=0&id=1a001824&lang=scss&scoped=true"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a001824"]])

export default __exports__